import { requestReceipt, uploadImage } from '../../api/request.js'

const state = {
  display: {
    languageList: false,
    completeMessage: false
  },
  config: {
    language: 'ko'
  },
  data: {
    currencyCode: 'USD'
  }
}

const getters = {
  GET_LANGUAGE_LIST (state) {
    return state.display.languageList;
  },
  GET_LANGUAGE (state) {
    return state.config.language;
  },
  GET_COMPLETE_MSG (state) {
    return state.display.completeMessage;
  },
  GET_CURRENCY_CODE (state) {
    return state.data.currencyCode;
  }
}

const mutations = {
  SET_LANGUAGE_LIST (state, data) {
    state.display.languageList = data
  },
  SET_LANGUAGE (state, data) {
    state.config.language = data;
  },
  SET_COMPLETE_MSG (state, data) {
    state.display.completeMessage = data;
  },
  SET_CURRENCY_CODE (state, data) {
    state.data.currencyCode = data;
  }
  
}

const actions = {
  TOGGLE_LANGUAGE_LIST (context, data) {
    context.commit('SET_LANGUAGE_LIST', data)
  },
  SET_LANGUAGE (context, data) {
    let promise = new Promise((resolve, reject) => {
      if(!data) {
        reject();
      }

      context.commit('SET_LANGUAGE', data);

      resolve();
    });

    return promise;
  },
  async REQUEST_RECEIPT (context, data) {
    try {
      let res = await requestReceipt(data)
      return res;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async UPLOAD_IMAGE (context, data) {
    try {
      let res = await uploadImage(data)
      return res;
    } catch (error) {
      return error;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
